module.exports = __webpack_public_path__ + "static/media/policeCar_green.fa696fec.svg";